import script from "./mainFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./mainFooter.vue?vue&type=script&setup=true&lang=js"

import "./mainFooter.vue?vue&type=style&index=0&id=fd0e6308&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd0e6308"]])

export default __exports__